import { render, staticRenderFns } from "./CatchupGroup.vue?vue&type=template&id=005300ef&scoped=true"
import script from "./CatchupGroup.vue?vue&type=script&lang=js"
export * from "./CatchupGroup.vue?vue&type=script&lang=js"
import style0 from "./CatchupGroup.vue?vue&type=style&index=0&id=005300ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005300ef",
  null
  
)

export default component.exports